import React, { useState, useEffect } from 'react';
import Portal from '../common/Portal';
import DatePicker from 'react-datepicker';

const AddFeedPurchaseModal = ({ isOpen, onClose, onSubmit, isLoading, feedItem }) => {
    const getInitialState = () => ({
        date: new Date(),
        quantity: '',
        totalCost: '',
    });
    const [purchaseData, setPurchaseData] = useState(getInitialState());

    useEffect(() => {
        if (isOpen) {
            setPurchaseData(getInitialState());
        }
    }, [isOpen]);

    if (!isOpen) return null;

    const handleChange = (e) => {
        setPurchaseData(prev => ({ ...prev, [e.target.name]: e.target.value }));
    };
    const handleDateChange = (date) => {
        setPurchaseData(prev => ({ ...prev, date }));
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(feedItem, purchaseData);
    };

    return (
        <Portal>
            <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
                <div className="bg-white rounded-lg shadow-xl p-8 w-full max-w-md m-4">
                    <h2 className="text-2xl font-bold mb-2">Record Purchase</h2>
                    <p className="text-sm text-gray-600 mb-6">For: {feedItem.name}</p>
                    <form onSubmit={handleSubmit} className="space-y-4">
                        <div>
                            <label className="block text-sm font-medium text-gray-700">Purchase Date</label>
                            <DatePicker
                                selected={purchaseData.date}
                                onChange={handleDateChange}
                                dateFormat="yyyy-MM-dd"
                                className="mt-1 block w-full form-input rounded-md shadow-sm"
                                wrapperClassName="w-full"
                                maxDate={new Date()}
                                portalId="portal-root"
                                popperClassName="high-z-datepicker"
                                required
                            />
                        </div>
                        <div>
                            <label htmlFor="quantity" className="block text-sm font-medium text-gray-700">Quantity Purchased (kg)</label>
                            <input type="number" step="any" name="quantity" id="quantity" value={purchaseData.quantity} onChange={handleChange} className="mt-1 block w-full form-input rounded-md shadow-sm" required />
                        </div>
                        <div>
                            <label htmlFor="totalCost" className="block text-sm font-medium text-gray-700">Total Cost (₹)</label>
                            <input type="number" step="0.01" name="totalCost" id="totalCost" value={purchaseData.totalCost} onChange={handleChange} className="mt-1 block w-full form-input rounded-md shadow-sm" required />
                        </div>
                        <div className="pt-5 flex justify-end space-x-3">
                            <button type="button" onClick={onClose} className="px-4 py-2 bg-gray-200 text-gray-800 rounded-md hover:bg-gray-300">Cancel</button>
                            <button type="submit" disabled={isLoading} className="px-4 py-2 bg-indigo-600 text-white rounded-md hover:bg-indigo-700 disabled:bg-indigo-300 flex items-center">
                                {isLoading ? 'Saving...' : 'Save Purchase'}
                            </button>
                        </div>
                    </form>
                </div>
            </div>
        </Portal>
    );
};

export default AddFeedPurchaseModal;